module.exports = __webpack_public_path__ + "img/uo_refresh_icon-1.606c949e.svg";